export default __webpack_public_path__ + "static/media/breast-cancer-histogram.36ebd930.png";